import {
  IHideOffer,
  EHideOfferState,
  IHideOfferComplainToggleAction,
  IHideOfferTopPopupToggleAction,
  ISetHideOfferState,
} from './types';

const defaultState: IHideOffer = {
  status: EHideOfferState.INIT,
  isComplainOpened: false,
  isTopPopupOpened: false,
};

export function hideOfferReducer(
  state: IHideOffer,
  action: IHideOfferComplainToggleAction | IHideOfferTopPopupToggleAction | ISetHideOfferState,
): IHideOffer {
  const { type, ...payload } = action;

  switch (type) {
    case 'IHideOfferComplainToggleAction':
      return {
        ...state,
        ...payload,
      };

    case 'IHideOfferTopPopupToggleAction':
      return {
        ...state,
        ...payload,
      };

    case 'ISetHideOfferState': {
      let isTopPopupOpened =
        (payload as ISetHideOfferState).status === EHideOfferState.SUCCESS ||
        (payload as ISetHideOfferState).status === EHideOfferState.ERROR ||
        state.isTopPopupOpened;

      if ((payload as ISetHideOfferState).status === EHideOfferState.FETCHING) {
        isTopPopupOpened = false;
      }

      return {
        ...state,
        ...payload,
        isTopPopupOpened,
      };
    }

    default:
      return state || defaultState;
  }
}
